import { createViewData } from "../../App/ViewData"
import type { ICruise, ITrack, ITrip } from "../../Types"
import type { CruiseWriters } from "./writers"

export interface CruiseDataViewData {
  cruise: ICruise | undefined;
  trips: ITrip[] | undefined;
  tracks: ITrack[] | undefined;
  writers: CruiseWriters;
}

export const { Context: CruiseDataContext, useData: useCruiseData } =
  createViewData<CruiseDataViewData>("CruiseDataView");
